export default __webpack_public_path__ + "media/Crucible_left.e1de27770d7e100513db7f0cba18359b.svg";